module.exports = __webpack_public_path__ + "img/icon-advantage@3x2.bab716fe.png";